import { render, staticRenderFns } from "./RealLogModal.vue?vue&type=template&id=37805c58&"
import script from "./RealLogModal.vue?vue&type=script&lang=js&"
export * from "./RealLogModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports